const u = (id, w = 1800) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  departments: {
    ai: "/images/neurialabs-v2/dept-ai.webp",
    software: "/images/neurialabs-v2/dept-software.webp",
    cloud: "/images/neurialabs-v2/dept-cloud.webp",
    data: "/images/neurialabs-v2/dept-data.webp",
    cybersecurity: "/images/neurialabs-v2/dept-cybersecurity.webp",
    hardware: "/images/neurialabs-v2/dept-hardware.webp",
    semiconductors: "/images/neurialabs-v2/dept-semiconductors.webp",
    iot: "/images/neurialabs-v2/dept-iot.webp",
    system: "/images/neurialabs-v2/dept-system.webp",
    gaming: "/images/neurialabs-v2/dept-gaming.webp",
    media: "/images/neurialabs-v2/dept-media.webp",
    "financial-technologies": "/images/neurialabs-v2/dept-financial-technologies.webp",
    mobility: "/images/neurialabs-v2/dept-mobility.webp",
    energy: "/images/neurialabs-v2/dept-energy.webp",
    "er-d": "/images/neurialabs-v2/dept-er-d.webp",
    equipment: "/images/neurialabs-v2/dept-equipment.webp",
    advertising: "/images/neurialabs-v2/dept-advertising.webp",
    events: "/images/neurialabs-v2/dept-events.webp",
    logistics: "/images/neurialabs-v2/dept-logistics.webp",
    "risk-responsibility": "/images/neurialabs-v2/dept-risk-responsibility.webp",
  },
  services: {
    "etude-et-cadrage": "/images/neurialabs-v2/v2b-service-framing.webp",
    "donnees-et-architecture": "/images/neurialabs-v2/v2-service-architecture.webp",
    "mobilisation-et-integration": "/images/neurialabs-v2/v2-service-integration.webp",
    "deploiement-et-exploitation": "/images/neurialabs-v2/v2d-service-operations.webp",
  },
  sectors: {
    "finance-et-assurance": "/images/neurialabs-v2/v2-sector-finance.webp",
    "sante-et-biotechnologies": "/images/neurialabs-v2/v2-sector-health.webp",
    "telecommunications-et-medias": "/images/neurialabs-v2/v2-sector-telecom.webp",
    "energie-et-environnement": "/images/neurialabs-v2/v2-sector-energy.webp",
    "immobilier-et-construction": "/images/neurialabs-v2/v2-sector-realestate.webp",
    "industrie-et-fabrication": "/images/neurialabs-v2/v2-sector-industry.webp",
    "commerce-et-distribution": "/images/neurialabs-v2/v2-sector-commerce.webp",
    "agriculture-et-agroalimentaire": "/images/neurialabs-v2/v2-sector-agri.webp",
    "transport-et-logistique": "/images/neurialabs-v2/v2-sector-transport.webp",
    "education-et-formation": "/images/neurialabs-v2/v2-sector-education.webp",
    "secteur-public-et-administration": "/images/neurialabs-v2/v2-sector-public.webp",
    "tourisme-hotellerie-et-loisirs": "/images/neurialabs-v2/v2-sector-tourism.webp",
    "culture-art-et-divertissement": "/images/neurialabs-v2/v2-sector-culture.webp",
    "technologie-et-innovation": "/images/neurialabs-v2/v2-sector-innovation.webp",
  },
  technologies: {
    "intelligence-artificielle": "/images/neurialabs-v2/v2-tech-ai.webp",
    "logiciels-et-plateformes": "/images/neurialabs-v2/v2-tech-software.webp",
    "cloud-et-calcul-distribue": "/images/neurialabs-v2/v2-tech-cloud.webp",
    donnees: "/images/neurialabs-v2/v2-tech-data.webp",
    cybersecurite: "/images/neurialabs-v2/v2-tech-cybersecurity.webp",
    "appareils-et-robotique": "/images/neurialabs-v2/v2-tech-robotics.webp",
    "composants-de-calcul": "/images/neurialabs-v2/v2b-tech-components.webp",
    "objets-connectes": "/images/neurialabs-v2/v2b-tech-iot.webp",
    "automatisation-et-systemes-industriels": "/images/neurialabs-v2/v2-tech-automation.webp",
    "creation-audiovisuel-et-immersion": "/images/neurialabs-v2/v2-tech-audiovisual.webp",
    mobilite: "/images/neurialabs-v2/v2-tech-mobility.webp",
    energie: "/images/neurialabs-v2/v2-tech-energy.webp",
    "recherche-simulation-et-validation": "/images/neurialabs-v2/v2-tech-simulation.webp",
  },
  about: { hero: "/images/neurialabs-v2/v2-page-about-hero.webp", organization: "/images/neurialabs-v2/v2-page-about-org.webp", industrial: "/images/neurialabs-v2/v2-page-about-industrial.webp" },
  contact: "/images/neurialabs-v2/v2-page-contact.webp",
  careers: "/images/neurialabs-v2/v2-page-careers.webp",
  activities: "/images/neurialabs-v2/v2-page-activities.webp",
  servicesPage: "/images/neurialabs-v2/v2-page-services.webp",
  solutionsPage: "/images/neurialabs-v2/v2-page-solutions.webp",
  technologiesPage: "/images/neurialabs-v2/v2-page-technologies.webp",
};

export const HERO_SLIDES = [
  { id: "autonomous", video: "/videos/campaign/autonomous-v2-stream.mp4", webm: "/videos/campaign/autonomous-v2-stream.webm", poster: "/videos/campaign/autonomous-v2-poster.webp" },
  { id: "humanoid", video: "/videos/campaign/humanoid-v6-stream.mp4", webm: "/videos/campaign/humanoid-v6-stream.webm", poster: "/videos/campaign/humanoid-v6-poster.webp" },
];
